var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZaFlag = function SvgZaFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "za-flag_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".za-flag_svg__cls-4{fill:#fff}"))), /*#__PURE__*/React.createElement("path", {
    d: "M44.78 12H23.63a.64.64 0 0 1-.4-.13L5.56.11 5.43 0H0v3.63l.15.08 16.77 11.18.15.11-.14.1L.13 26.3l-.13.07V30h5.43a.43.43 0 0 1 .1-.09Q14.41 24 23.3 18.07a.52.52 0 0 1 .3-.08H45V12Z",
    style: {
      fill: "#007a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 0 14.9 9.93a.49.49 0 0 0 .25.05H45V0Z",
    style: {
      fill: "#de3831"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.15 20a.42.42 0 0 0-.24.07l-14.8 9.87L9 30h36V20Z",
    style: {
      fill: "#002395"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.38 14.91.11 6.06 0 6v18l3.07-2 10.28-6.86.15-.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "za-flag_svg__cls-4",
    d: "M44.8 10H24.18a.49.49 0 0 1-.25-.05L9 0H5.43l.13.11 17.67 11.78a.64.64 0 0 0 .4.13H45V10ZM44.78 18H23.6a.52.52 0 0 0-.3.08Q14.41 24 5.53 29.91a.43.43 0 0 0-.1.09H9l.08-.06 14.8-9.86a.42.42 0 0 1 .24-.07H45V18Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 24 3.07-2 10.28-6.86.15-.14-.12-.09L.11 6.06 0 6V3.63l.15.08 16.77 11.18.15.11-.14.1L.13 26.3l-.13.07Z",
    style: {
      fill: "#ffb612"
    }
  }));
};
export default SvgZaFlag;